import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import decode from 'jwt-decode';
import Cookies from 'universal-cookie';
import gql from 'graphql-tag';
import { AuthClient } from '@emyw/core-lib';
const {
  REACT_APP_ENJOY_EXTENSION_ID
} = process.env;
const {
  REACT_APP_JOYIFY_EXTENSION_ID
} = process.env;
const {
  REACT_APP_TOKEN_NAME,
  REACT_APP_REFRESH_TOKEN_NAME
} = process.env;
export const decodeAuthToken = (enjoyToken, enjoyRefreshToken) => {
  const lsToken = enjoyToken || localStorage.getItem(REACT_APP_TOKEN_NAME);
  const lsRefreshToken = enjoyRefreshToken || localStorage.getItem(REACT_APP_REFRESH_TOKEN_NAME);
  try {
    const token = decode(lsToken);
    const refreshToken = decode(lsRefreshToken);
    // Check if the refresh token is expired.
    if (Date.now() / 1000 > refreshToken.exp) {
      return null;
    }
    return token;
  } catch (err) {
    return null;
  }
};

// pulls the selector and validator from the remember me cookie if one exists.
const getRemCookieValues = () => {
  const cookies = new Cookies();
  const rem = cookies.get('rem');
  if (rem && rem.selector && rem.validator) {
    return [rem.selector, rem.validator];
  }
  return [null, null];
};
const selectorLoginMutation = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    mutation ($selector: String!, $validator: String!) {\n        selectorLogin(selector: $selector, validator: $validator) {\n            ok\n            token\n            refreshToken\n            errors {\n                path\n                message\n            }\n        }\n    }\n"])));
export const tryRemembering = async () => {
  // get the selector and validator from the cookie
  const [selector, validator] = getRemCookieValues();
  if (selector === null || validator === null) {
    // No remember me cookie found. Redirect to login
    // log.trace('login 1');
    return false;
  }

  // we found a cookie so lets try to re-login for the user
  const response = await AuthClient.mutate({
    mutation: selectorLoginMutation,
    variables: {
      selector,
      validator
    }
  });
  const {
    ok,
    token,
    refreshToken
  } = response.data.selectorLogin; // errors
  if (ok) {
    localStorage.setItem(REACT_APP_TOKEN_NAME, token);
    localStorage.setItem(REACT_APP_REFRESH_TOKEN_NAME, refreshToken);
    return true;
  }
  return false;
};

/* Get authenticated user id - note: params enjoyToken & enjoyRefreshToken are optional */
export const getAuthenticatedUserId = async function (enjoyToken, enjoyRefreshToken) {
  let notifyExtension = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  // log.trace('checking auth');
  let token = decodeAuthToken(enjoyToken, enjoyRefreshToken);
  // log.trace(`token: ${JSON.stringify(token)}`);
  if (token === null && (await tryRemembering())) {
    token = decodeAuthToken();
  }
  if (token === null) return -1;
  try {
    const {
      user
    } = token;
    // log.trace(`user: ${user}`);
    // NOTE: once the mv3 extension is rolled out, this code to send the extension a message will no longer be needed
    // and is actually ignored by the mv3 version
    if (user.id && notifyExtension) {
      // Notify any extension background script that also needs to logout
      const authTokens = {
        token: enjoyToken || localStorage.getItem(REACT_APP_TOKEN_NAME),
        refreshToken: enjoyRefreshToken || localStorage.getItem(REACT_APP_REFRESH_TOKEN_NAME)
      };
      if (window.chrome) {
        if (REACT_APP_ENJOY_EXTENSION_ID || REACT_APP_JOYIFY_EXTENSION_ID) {
          // log.trace('sending tokens to extensions');
          if (REACT_APP_ENJOY_EXTENSION_ID) {
            try {
              window.chrome.runtime.sendMessage(REACT_APP_ENJOY_EXTENSION_ID, {
                authTokens
              });
            } catch (error) {
              log.warn('Attempt to notify Enjoy Chrome extension failed. Perhaps an unsupported browser is being used.');
            }
          }
          if (REACT_APP_JOYIFY_EXTENSION_ID) {
            try {
              window.chrome.runtime.sendMessage(REACT_APP_JOYIFY_EXTENSION_ID, {
                authTokens
              });
            } catch (error) {
              log.warn('Attempt to notify Joyify-it Chrome extension failed. Perhaps an unsupported browser is being used.');
            }
          }
        }
      } else {
        log.warn('Cannot notify extension - window.chrome undefined. Perhaps an unsupported browser is being used.');
      }
    }
    return user.id;
  } catch (err) {
    // return an invalid id to allow this method to be easily used with a check for > 0
    // for when there is no authenticated user.
    // log.trace(err);
    return -1;
    // throw new Error(`No authenticated user exists. Err: ${err}`);
  }
};

/* Get authenticated active profile id and user id - note: params enjoyToken & enjoyRefreshToken are optional */
export const getAuthenticatedActiveProfileId = async function (enjoyToken, enjoyRefreshToken) {
  let notifyExtension = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  // log.trace('checking auth');
  let token = decodeAuthToken(enjoyToken, enjoyRefreshToken);
  // log.trace(`token: ${JSON.stringify(token)}`);
  if (token === null && (await tryRemembering())) {
    token = decodeAuthToken();
  }
  if (token === null) return {
    userId: -1,
    profileId: -1
  };
  try {
    const {
      user
    } = token;
    // log.trace(`user: ${user}`);
    // NOTE: once the mv3 extension is rolled out, this code to send the extension a message will no longer be needed
    // and is actually ignored by the mv3 version
    if (user.id && notifyExtension) {
      // Notify any extension background script that also needs to logout
      const authTokens = {
        token: enjoyToken || localStorage.getItem(REACT_APP_TOKEN_NAME),
        refreshToken: enjoyRefreshToken || localStorage.getItem(REACT_APP_REFRESH_TOKEN_NAME)
      };
      if (window.chrome) {
        if (REACT_APP_ENJOY_EXTENSION_ID || REACT_APP_JOYIFY_EXTENSION_ID) {
          // log.trace('sending tokens to extensions');
          if (REACT_APP_ENJOY_EXTENSION_ID) {
            try {
              window.chrome.runtime.sendMessage(REACT_APP_ENJOY_EXTENSION_ID, {
                authTokens
              });
            } catch (error) {
              log.warn('Attempt to notify Enjoy Chrome extension failed. Perhaps an unsupported browser is being used.');
            }
          }
          if (REACT_APP_JOYIFY_EXTENSION_ID) {
            try {
              window.chrome.runtime.sendMessage(REACT_APP_JOYIFY_EXTENSION_ID, {
                authTokens
              });
            } catch (error) {
              log.warn('Attempt to notify Joyify-it Chrome extension failed. Perhaps an unsupported browser is being used.');
            }
          }
        }
      } else {
        log.warn('Cannot notify extension - window.chrome undefined. Perhaps an unsupported browser is being used.');
      }
    }
    return {
      userId: user.id,
      profileId: user.activeProfileId
    };
  } catch (err) {
    // return an invalid id to allow this method to be easily used with a check for > 0
    // for when there is no authenticated user.
    // log.trace(err);
    return {
      userId: -1,
      profileId: -1
    };
    // throw new Error(`No authenticated user exists. Err: ${err}`);
  }
};

/* Get if user is authenticated - note: params enjoyToken & enjoyRefreshToken are optional */
export const isAuthenticated = async (enjoyToken, enjoyRefreshToken) => (await getAuthenticatedUserId(enjoyToken, enjoyRefreshToken)) > 0;
export const logOut = () => {
  try {
    if (window.chrome) {
      if (REACT_APP_ENJOY_EXTENSION_ID || REACT_APP_JOYIFY_EXTENSION_ID) {
        log.trace('sending logout request to extensions');
        if (REACT_APP_ENJOY_EXTENSION_ID) {
          try {
            window.chrome.runtime.sendMessage(REACT_APP_ENJOY_EXTENSION_ID, {
              logOut: true
            });
          } catch (error) {
            log.warn('Attempt to notify Enjoy Chrome extension failed. Perhaps an unsupported browser is being used.');
          }
        }
        if (REACT_APP_JOYIFY_EXTENSION_ID) {
          try {
            window.chrome.runtime.sendMessage(REACT_APP_JOYIFY_EXTENSION_ID, {
              logOut: true
            });
          } catch (error) {
            log.warn('Attempt to notify Joyify-it Chrome extension failed. Perhaps an unsupported browser is being used.');
          }
        }
      }
    } else {
      log.warn('Cannot notify extension - window.chrome undefined. Perhaps an unsupported browser is being used.');
    }
    localStorage.removeItem(REACT_APP_TOKEN_NAME);
    localStorage.removeItem(REACT_APP_REFRESH_TOKEN_NAME);
    const cookies = new Cookies();
    cookies.remove('rem', {
      path: '/'
    });
  } catch (err) {
    return false;
  }
  return true;
};
export const normalizeErrors = (errors, catchUnknownPathInto, forceUnknown) => {
  let path;
  let message;
  if (errors && errors !== null && errors.reduce) {
    return errors.reduce((acc, cv) => {
      path = (cv.path === 'unknown' || forceUnknown) && catchUnknownPathInto ? catchUnknownPathInto : cv.path;
      ({
        message
      } = cv);
      if (path === 'ix_Profile_userId_name') {
        path = 'name';
        message = message.replace(/ix_Profile_userId_name/, 'profile name');
      }
      if (path in acc) {
        acc[path].push(message);
      } else {
        acc[path] = [message];
      }
      return acc;
    }, {});
  }
  return errors;
};
export const getRootUrl = () => window.location.origin ? "".concat(window.location.origin, "/") : "".concat(window.location.protocol, "/").concat(window.location.host, "/");
export const isOpera = !!window.opr && !!window.opr.addons || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0; // Opera 8.0+
export const isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime); // Chrome 1 - 71
export const isBlink = (isChrome || isOpera) && !!window.CSS;